import { getAttendeeId } from '../selectors/currentRegistrant';

export function recordViewSpeakerProfileActivity(speakerId) {
  return (dispatch, getState) => {
    if (speakerId) {
      const {
        event: { id: eventId },
        clients: { eventGuestClient },
        accessToken
      } = getState();

      const attendeeId = getAttendeeId(getState());

      // For now we are only tracking this for confirmed attendees. Next phase, we will track this for invitees
      if (attendeeId) {
        const fact = {
          type: 'event_website_speaker_profile_view',
          eventId,
          attendeeId,
          speakerId
        };

        eventGuestClient.publishAttendeeActivityFact(accessToken, fact);
      }
    }
  };
}
